// extracted by mini-css-extract-plugin
export var article = "content-module--article--XJZwT";
export var section = "content-module--section--33P45";
export var head = "content-module--head--12T-7";
export var title = "content-module--title--2bDHi";